import React from 'react';
import { Button } from './Button';
export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  'data-id'?: string;
}
export function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
  'data-id': dataId
}: EmptyStateProps) {
  return <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`} data-id="element-2802">
      {icon && <div className="w-16 h-16 flex items-center justify-center bg-background rounded-full text-text-muted mb-4" data-id="element-2803">
          {icon}
        </div>}

      <h3 className="text-h3 font-semibold text-text-primary mb-2" data-id="element-2804">{title}</h3>

      {description && <p className="text-body text-text-secondary max-w-md mb-6" data-id="element-2805">
          {description}
        </p>}

      {action && <Button onClick={action.onClick} data-id="element-2806">{action.label}</Button>}
    </div>;
}